import { createFileRoute } from '@tanstack/react-router'
import { Doctors } from '@/features/doctors'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/doctors/')({
  beforeLoad: requireAdmin,
  component: Doctors,
})
